import { IRatePlan } from 'modules/settings/models';
import API from 'services/api';

export const getRatePlan = (ratePlanId: string | null): Promise<IRatePlan> => {
  return API.get(`/api/accommodation/rate-plan/${ratePlanId}`).then(res => res?.data);
};
